import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_APPLICATIONS } from '@/api/endpoints';
import {
  NON_ATTENDANCE_APPLICATIONS_QUERY_KEY,
  NON_ATTENDANCE_APPLICATION_QUERY_KEY,
} from '@/api/queryKeys';
import { joinPath } from '@/utils/global';

export const useCancelNonAttendanceApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) =>
      apiClient.delete<unknown>(
        joinPath(API_NON_ATTENDANCE_APPLICATIONS, String(id)),
      ),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({
        queryKey: [...NON_ATTENDANCE_APPLICATION_QUERY_KEY, id],
      });
      queryClient.invalidateQueries({
        queryKey: NON_ATTENDANCE_APPLICATIONS_QUERY_KEY,
      });
    },
  });
};
